import React, { Component } from "react";
import OlMap from "ol/Map";
import OlView from "ol/View";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Image as ImageLayer,
} from "ol/layer";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import {
  defaults as defaultControls,
  ScaleLine,
  OverviewMap,
} from "ol/control.js";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom,
} from "ol/interaction.js";
import { OSM } from "ol/source";
import { fromLonLat } from "ol/proj";
import { Fill, Style, Stroke, Circle } from "ol/style";
import { Overlay } from "ol";
import ImageWMS from "ol/source/ImageWMS";
import { ZoomToExtent } from "ol/control.js";
import { View } from "ol";
import SimpleGeometry from "ol/geom/SimpleGeometry";
import { getCenter } from "ol/extent";
import { searchrdfquery, mapData } from "../../api/kugi";
import "./marker.css";
import queryString from "query-string";
import { Button } from "@material-ui/core";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import "ol/ol.css";
// import ImageLayer from "ol/layer/Image";

class MapDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [0, 0],
      zoom: 10,
      kx: 0,
      ky: 0,
      keterangan: "",
      idObject: "",
      loading: true,
    };
  }

  componentDidMount() {
    const id = this.handleId(this.props.id);
    const scaleLineControl = new ScaleLine();
    const overviewMapControl = new OverviewMap({
      className: "ol-overviewmap ol-custom-overviewmap",
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      collapseLabel: "\u00BB",
      label: "\u00AB",
      collapsed: true,
    });
    this.olmap = new OlMap({
      target: null,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      controls: defaultControls({
        attributionOptions: { collapsible: true },
      }).extend([
        // overviewMapControl,
        // scaleLineControl
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      view: new OlView({
        center: fromLonLat(this.state.center),
        zoom: this.state.zoom,
      }),
    });
    this.olmap.setTarget(`map${this.props.sublayer}`);
    const image = new Circle({
      radius: 10,
      fill: new Fill({
        color: "rgba(42,99,181, 0.3)",
      }),
      stroke: new Stroke({ color: "rgb(73,122,194)", width: 5 }),
    });

    const styles = {
      Point: new Style({
        image: image,
      }),
      LineString: new Style({
        stroke: new Stroke({
          color: "green",
          width: 1,
        }),
      }),
      MultiLineString: new Style({
        stroke: new Stroke({
          color: "rgb(73,122,194)",
          width: 5,
        }),
      }),
      MultiPoint: new Style({
        image: image,
      }),
      MultiPolygon: new Style({
        stroke: new Stroke({
          color: "rgb(73,122,194)",
          width: 1,
        }),
        fill: new Fill({
          color: "rgba(42,99,181, 0.3)",
        }),
      }),
      Polygon: new Style({
        stroke: new Stroke({
          color: "blue",
          lineDash: [4],
          width: 3,
        }),
        fill: new Fill({
          color: "rgba(0, 0, 255, 0.1)",
        }),
      }),
      GeometryCollection: new Style({
        stroke: new Stroke({
          color: "magenta",
          width: 2,
        }),
        fill: new Fill({
          color: "magenta",
        }),
        image: new Circle({
          radius: 10,
          fill: null,
          stroke: new Stroke({
            color: "magenta",
          }),
        }),
      }),
      Circle: new Style({
        stroke: new Stroke({
          color: "red",
          width: 2,
        }),
        fill: new Fill({
          color: "rgba(255,0,0,0.2)",
        }),
      }),
    };
    const styleFunction = function(feature) {
      return styles[feature.getGeometry().getType()];
    };

    const typeName = `&typename=${this.props.layer}:${this.props.sublayer}`
    const filter = `&CQL_FILTER=${this.props.filter}=${id}`

    const source2 = new VectorSource({
      url: `${this.props.host}${typeName}${filter}`,
      format: new GeoJSON(),
    });
    const vector2 = new VectorLayer({
      source: source2,
      visible: true,
      style: styleFunction,
    });
    vector2.getSource().on("addfeature", (e) => {
      this.olmap.getView().fit(vector2.getSource().getExtent());
      if (this.props.type === 'Point') {
        this.olmap.getView().setZoom(14)
      }
    });
    this.olmap.addLayer(vector2);
    this.setState({ loading: false });
  }

  handleId = (id) => {
    if (this.props.sublayer === "taswil_kabkot_ar") return `${id}`;
    else return `'${id}'`;
  };

  render() {
    return (
      <BlockUi
        blocking={this.state.loading}
        color="#497ac2"
        message="Loading..."
      >
        <div
          id={`map${this.props.sublayer}`}
          style={{
            width: "100%",
            height: "200px",
          }}
        >
        </div>
      </BlockUi>
    );
  }
}

export default MapDialog;
